export default {
  namespaced: true,

  state: {
    formCache: {},
  },

  mutations: {
    SET_FORM_DATA(state, { id, data }) {
      const currentData = data.body.map((element) => {
        if (element.metadata.type === 'BaseLookup' && (Array.isArray(element.props.value) && element.props.value.length)) {
          const currentElement = element;
          currentElement.props.value = element.props.value
            .map((value) => value[element.props.keyfield]);
        }
        return element;
      });

      const cache = sessionStorage.getItem('form-cache');

      if (cache) {
        state.formCache = JSON.parse(cache);
      }

      state.formCache = {
        ...state.formCache,
        [id]: {
          ...data,
          body: currentData,
        },
      };

      sessionStorage.setItem('form-cache', JSON.stringify(state.formCache));
    },

    CLEAR_FORM_DATA(state, id) {
      if (Object.prototype.hasOwnProperty.call(state.formCache, id)) {
        delete state.formCache[id];
        sessionStorage.setItem('form-cache', JSON.stringify(state.formCache));
      }
    },
  },

  actions: {
    saveFormData({ commit }, { id, data }) {
      commit('SET_FORM_DATA', { id, data });
    },
    clearFormData({ commit }, id) {
      commit('CLEAR_FORM_DATA', id);
    },
  },

  getters: {
    getFormData: () => (id) => {
      const formCache = JSON.parse(sessionStorage.getItem('form-cache')) || {};
      return formCache[id] || null;
    },
  },
};
